import { lazy, useEffect } from 'react';
import { Route, Routes } from 'react-router';

import { DictTypes } from '@/constants';
import { isDictHasAll } from '@/services/helpers/dict';
import { useAppDispatch, useAppSelector } from '@/store';
import { getOptimizedDictionaries } from '@/store/dict.slice';

import { FAQ_ROUTES } from '../Shared/routes/routes';
import FaqLayout from './FaqLayout';

const Faq = lazy(() => import('./Faq/Faq'));
const FaqArticle = lazy(() => import('./FaqArticle/FaqArticle'));

const FaqRoutes: React.FC = () => {
  const dispatch = useAppDispatch();
  const { dicts } = useAppSelector((state) => state.dict);

  useEffect(() => {
    if (
      isDictHasAll(dicts, [
        DictTypes.FaqPagesTypes,
        DictTypes.Modules,
        DictTypes.Positions
      ])
    )
      return;

    dispatch(
      getOptimizedDictionaries({
        dictTypes: [
          DictTypes.FaqPagesTypes,
          DictTypes.Modules,
          DictTypes.Positions
        ]
      })
    );
  }, [dicts]);

  return (
    <Routes>
      <Route path="/" element={<FaqLayout />}>
        <Route index element={<Faq />} />
        <Route path={FAQ_ROUTES.faqArticle()} element={<FaqArticle />} />
      </Route>
    </Routes>
  );
};

export default FaqRoutes;
